export const TOKEN_ADDRESS = process.env.NEXT_PUBLIC_TOKEN_ADDRESS;
export const PAIR_ADDRESS = process.env.NEXT_PUBLIC_PAIR_ADDRESS;
